import {exhibitionScenarioConstants} from "../constants/exhibition-scenario.constants";
import {exhibitionScenarioService} from "../services/exhibition-scenario.service";
import {modalActions} from "./modal.actions";

const getListExhibitionScenario = () => {
    return dispatch => {
        dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_LIST_REQUEST});
        exhibitionScenarioService.getList()
            .then(
                (scenario) => {
                    dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_LIST_SUCCESS, scenario})
                },
                (error) => {
                    dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_LIST_FAILURE, error});
                }
            )
    }
}

const getByIdExhibitionScenario = (id) => {
    return dispatch => {
        dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_GET_BY_ID_REQUEST});
        exhibitionScenarioService.getById(id)
            .then(
                (scenario) => {
                    dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_GET_BY_ID_SUCCESS, scenario})
                },
                (error) => {
                    dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_GET_BY_ID_FAILURE, error});
                }
            )
    }
}

const createExhibitionScenario = (scenarioModel) => {
    return dispatch => {
        exhibitionScenarioService.create(scenarioModel)
            .then(
                () => {
                    dispatch(getListExhibitionScenario());
                    dispatch(modalActions.hideModal());
                },
                (error) => {
                    dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_VALIDATION_ERROR, error})
                }
            )
    }
}

const editExhibitionScenario = (scenarioModel) => {
    return dispatch => {
        exhibitionScenarioService.edit(scenarioModel)
            .then(
                () => {
                    dispatch(getListExhibitionScenario());
                    dispatch(modalActions.hideModal());
                },
                (error) => {
                    dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_VALIDATION_ERROR, error})
                }
            )
    }
}

const deleteExhibitionScenario = (id) => {
    return dispatch => {
        exhibitionScenarioService.remove(id)
            .then(
                () => {
                    dispatch(getListExhibitionScenario());
                    dispatch(modalActions.hideModal());
                },
                (error) => {
                    dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_VALIDATION_ERROR, error})
                }
            )
    }
}

const getDropdownListExhibitionScenario = () => {
    return dispatch => {
        dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_DROPDOWN_LIST_REQUEST});
        exhibitionScenarioService.getDropdownList()
            .then(
                (scenario) => {
                    dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_DROPDOWN_LIST_SUCCESS, scenario})
                },
                (error) => {
                    dispatch({type: exhibitionScenarioConstants.EXHIBITION_SCENARIO_DROPDOWN_LIST_FAILURE, error});
                }
            )
    }
}

export const exhibitionScenarioActions = {
    getListExhibitionScenario,
    getByIdExhibitionScenario,
    createExhibitionScenario,
    editExhibitionScenario,
    deleteExhibitionScenario,
    getDropdownListExhibitionScenario
}